import axios from 'axios'
import Vue from 'vue'

let axiosIns = axios.create({});


// axiosIns.defaults.baseURL = ''

axiosIns.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.responseType = 'json';


axiosIns.defaults.validateStatus = function (status) {
    return true;
};

//发请求拦截，有需要自行添加
axiosIns.interceptors.request.use((config) =>{
    config.headers.Accept = 'application/json, text/plain, */*';
    return config;
});

let ajaxMethod = ['get', 'post'];
let api = {};
ajaxMethod.forEach((method)=> {
    //数组取值的两种方式
    api[method] = function (uri, data, config) {
        return new Promise(function (resolve, reject) {
            axiosIns[method](uri, data, config).then((res)=> {
              resolve(res.data);
            }).catch((err)=> {
              console.log(err)
            })
        })
    }
});

export default api;


// WEBPACK FOOTER //
// ./src/axios.js